var map = {
	"./retailquantofy.png": 96,
	"./retailquantofy10.png": 1763,
	"./retailquantofy2.png": 1840,
	"./retailquantofy3.png": 8745,
	"./retailquantofy4.png": 5670,
	"./retailquantofy5.png": 4687,
	"./retailquantofy6.png": 5780,
	"./retailquantofy7.png": 6909,
	"./retailquantofy8.png": 2842,
	"./retailquantofy9.png": 1699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6768;